import { PageTitleGoBack } from 'components/base/title/PageTitle';
import AppModal from 'components/common/modal/AppModal';
import PlainModal from 'components/common/modal/PlainModal';
import ProjectContents from 'components/project/clinic/ProjectContents';
import ProjectReworkModal from 'components/project/clinic/ProjectReworkModal';
import ProjectSkeleton from 'components/project/clinic/ProjectSkeleton';
import ProjectTimeline from 'components/project/clinic/ProjectTimeline';
import { pmsViewThumbnail } from 'containers/base/PmsConnect';
import { PrivateSocketContext } from 'contexts/PrivateSocketContext';
import { ProjectContext } from 'contexts/project/ProjectContext';
import { ProjectSocketContext } from 'contexts/ProjectSocketContext';
import { useProject } from 'lib/hooks/project/useProject';
import { useProjectDetail } from 'lib/hooks/project/useProjectDetail';
import { pageUrl } from 'lib/mapper';
import { ITeeth, Tooth } from 'lib/types/projectTypes';
import { useDidUpdateEffect } from 'lib/utils';
import moment from 'moment';
import queryString from 'query-string';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import {
  EmployeeActions,
  FileActions,
  ProjectActions,
  UserActions,
  UtilActions,
} from 'store/actionCreators';
import { useProjectDetailStore } from 'store/local/projectDetail';
import { useProjectFileStore } from 'store/local/projectFile';
import styled from 'styled-components';
import ProjectChatContainer from '../ProjectChatContainer';
import { useCreateProjectInfoStore } from 'store/local/projectCreateinfo';
import CreateProjectInfo from 'components/project/clinic/CreateProjectInfo';
import CreateProjectContent from 'components/project/clinic/CreateProjectContent';
import ClinicModal from 'components/common/modal/ClinicModal';
import { transform } from 'lodash';
import { useQuickStart } from 'lib/hooks/quickstart/useQuickStart';
import CreateProjectLibrary from 'components/project/clinic/CreateProjectLibrary';

function ProjectContainer() {
  // SECTION: declare local store
  const {
    isInfoOpen,
    setIsInfoOpen,
    isIndicationOpen,
    setIsIndicationOpen,
    isLibraryOpen,
    setIsLibraryOpen,
    reset: createProjectInfoReset,
  } = useCreateProjectInfoStore();

  const { ipcRenderer } = window;
  const history = useHistory();
  const location = useLocation();
  const { search, pathname } = location as {
    search: string;
    pathname: string;
  };
  const queryParse = queryString.parse(search);
  // const pageTab = !!queryParse?.tab ? queryParse?.tab : 0;
  const pageTab = Number(queryParse?.tab) || 0;
  const [scanStart, setScanStart] = useState<number>(Number(queryParse?.scanStart) || 0);

  const isFromEditComponent = !!location?.state?.isFromEditComponent;

  const isFromCreating = !!location?.state?.isFromCreating;
  const { t } = useTranslation();
  const { projectAcceptEvent } = useContext(PrivateSocketContext);
  const { newProjectChat, isChatOpen } = useContext(ProjectSocketContext);

  const {
    onListenerClinicLocalFiles,
    localFileListCt,
    clinicFileListReset,
    onRomoveLocalFile,
    classifyClinicFiles,
  } = useContext(ProjectContext);

  const { upperFiles, lowerFiles, occlusionFiles, photoFiles, etcFiles, noneFiles } =
    classifyClinicFiles;
  const [eventTargetRef, setEventTargetRef] = useState<any>();
  const [isProjectGet, setIsProjectGet] = useState<boolean>(false);

  const {
    isShowChat,
    isProjectCreator,
    setIsProjectCreator,
    teeth,
    setTeeth,
    setTooth,
    setToothShade,
    setScanMode,
    setNumbering,
    setBridge,
    setSelectedTeethIsExpanded,
    reworkStatusModalOpen,
    setReworkList,
    setProjectId,
    selectedSyncPartner,
    newSyncPartner,
    queryPageTab,
    setQueryPageTab,
    isPhotogrammetry,
    reset: projectDetailReset,
  } = useProjectDetailStore();

  const { reset: projectFileReset } = useProjectFileStore();

  const {
    user,
    language,
    projectCode,
    projectInfo,
    newChatCount,
    isOwner,
    hasSyncAlarm,
    fetchProjectSuccess,
    projectFilesSuccess,
    handleClickChat,
    projectIndication,
    handleClickProjectTab,
    isPmsReady,
    pmsCommand,
    pmsData,
    isPmsOrder,
    projectCount,
    projectInitSuccess,
    projectCopyCount,
    projectCopyInfo,
    fetchCopyProjectSuccess,
    editProjectData,
    editProjectSuccess,
    fetchProjectFailure,
    isValidProjectInfo,
    isPim,
  } = useProject();

  const { handleCloseReworkStatusModal } = useProjectDetail();

  const {
    clientGroupCode,
    projectName,
    enrollDate,
    ownerName,
    partnerName,
    projectId,
    ownerReworkType,
    partnerReworkType,
  } = projectInfo;

  const { handleSendExcuteApp } = useQuickStart();
  // SECTION: variable

  // SECTION: declare hooks

  // SECTION: declare function
  const handleClickGoToBack = () => {
    if (!!isFromEditComponent || !!isFromCreating) {
      history.go(-2);
    } else {
      history.goBack();
    }
  };

  const handleCloseInfo = () => {
    setIsInfoOpen(false);
  };

  const handleCloseLibrary = () => {
    setIsLibraryOpen(false);
  };

  const handleCloseIndication = () => {
    setIsIndicationOpen(false);
  };

  useEffect(() => {
    if (!projectCode) return;
    ProjectActions.fetch_project_request(projectCode);
    ProjectActions.set_projects({ projectCode, hasNewEvent: false });
  }, [projectCode]);

  useEffect(() => {
    if (!user.groupCode) return;
    UtilActions.fetch_teeth_indication_info_request({
      groupCode: !!user.groupCode ? user.groupCode : '',
    });
  }, [user]);

  useEffect(() => {
    EmployeeActions.fetch_manager_list_request();
    UserActions.fetch_profile_request();
    return () => {
      projectDetailReset();
      projectFileReset();
      clinicFileListReset();
      createProjectInfoReset();
    };
  }, []);

  useEffect(() => {
    if (!!scanStart && !!projectCode && !!projectId) {
      console.log('HDS] scanStart -________- ', scanStart);
      handleSendExcuteApp({
        appName: 'APP_SCAN_IOS',
        projectCode: projectCode,
        projectId: projectId,
        isPIM: !!isPhotogrammetry ? 1 : 0,
      });
      setScanStart(0);
      const urlWithoutQuery = window.location.origin + window.location.pathname; // Query string 제외한 URL 생성
      console.log('HDS] urlWithoutQuery __________ ', urlWithoutQuery);
      window.history.replaceState({}, document.title, urlWithoutQuery);
    }
  }, [scanStart, projectCode, projectId, isPhotogrammetry]);

  useEffect(() => {
    if (!ipcRenderer) return;
    ipcRenderer.on('projectFileLocalDeleteRes', (e: any, data: any) => {
      if (data.status) {
        onRomoveLocalFile(data.fileName);
      } else {
        // TODO: file delete 실패 알림
      }
    });
  }, []);

  useEffect(() => {
    return () => {
      isChatOpen.setValue(false);
      if (!history.location.state?.isFromCreating) ProjectActions.fetch_project_clear();
      if (!!eventTargetRef) {
        eventTargetRef.removeAllListeners('watchFileUpdate');
      }
      if (!!ipcRenderer) {
        ipcRenderer.send('watchStop');
      }
    };
  }, []);

  const teethIsExpanded = useMemo(() => {
    return teeth?.map((item: Tooth) => {
      return { number: item?.number, isExpanded: false };
    });
  }, [teeth]);

  useEffect(() => {
    setSelectedTeethIsExpanded(teethIsExpanded);
  }, [teethIsExpanded]);

  useEffect(() => {
    if (!pageTab) return;
    console.log('HDS] pageTab ______ ', pageTab);
    setQueryPageTab(pageTab);
    handleClickProjectTab(1);
    // pathname;
    // console.log('HDS] pathname _________ ', pathname);
    // window.location.assign(pathname);
  }, [pageTab]);

  useDidUpdateEffect(() => {
    if (!projectIndication) return;

    if (!!isPim === !!isPhotogrammetry) {
      console.log('HDS] projectIndication ________ ');
      const convertPimData = projectIndication.teeth.map((tooth: ITeeth) => {
        if (isPim) {
          return { ...tooth, hasPim: true, pimType: tooth.implantLibrary ? 'normal' : 'scanbody' };
        } else {
          return { ...tooth, hasPim: false };
        }
        // if (tooth.implantLibrary) {
        //   return { ...tooth, hasPim: true };
        // } else {
        //   return { ...tooth, hasPim: true };
        // }
      });
      setTeeth(convertPimData);
      setToothShade(projectIndication.shade);
      setScanMode(projectIndication.scanmode);
      setNumbering(projectIndication.notation);
      setBridge(projectIndication.bridgeList);
      setTooth({ number: null });
    } else {
      setTeeth([]);
      setToothShade(null);
      setScanMode(null);
      setNumbering(0);
      setBridge([]);
      setTooth({ number: null });
    }
  }, [isPim, isPhotogrammetry, projectIndication]);

  useDidUpdateEffect(() => {
    if (!ipcRenderer || !projectInfo || !projectFilesSuccess) return;
    ipcRenderer.send('projectGet', { projectInfo });
    ipcRenderer.on('projectGetRes', (e: any, data: any) => {
      setIsProjectGet(true);
    });
  }, [projectInfo, projectFilesSuccess]);

  useDidUpdateEffect(() => {
    if (!ipcRenderer || !projectInfo) return;
    if (isProjectGet) {
      ipcRenderer.send('watchStart', { projectId: projectInfo?.projectId });
    }
  }, [projectInfo, isProjectGet]);

  useDidUpdateEffect(() => {
    if (!ipcRenderer) return;
    if (!!eventTargetRef) {
      eventTargetRef.removeAllListeners('watchFileUpdate');
    }
    setEventTargetRef(
      ipcRenderer.on('watchFileUpdate', (e: any, data: any) => {
        onListenerClinicLocalFiles(data);
      }),
    );
  }, [
    localFileListCt.value,
    eventTargetRef,
    upperFiles.value,
    lowerFiles.value,
    occlusionFiles.value,
    photoFiles.value,
    etcFiles.value,
    noneFiles.value,
  ]);

  useDidUpdateEffect(() => {
    if (!fetchProjectSuccess) return;
    newProjectChat.setValue(newChatCount);
    UtilActions.fetch_remake_type_list_request({ groupCode: projectInfo?.ownerGroupCode });

    if (!ipcRenderer) return;
    if (!isPmsOrder) return;
    if (pmsCommand === pmsViewThumbnail) {
      handleClickProjectTab(1);
    }
  }, [fetchProjectSuccess, pmsCommand, isPmsOrder]);

  useDidUpdateEffect(() => {
    if (!fetchProjectSuccess) return;
    setProjectId(projectId);
    FileActions.fetch_project_files_request(projectCode);
    if (user.groupCode === projectInfo?.ownerGroupCode) {
      setIsProjectCreator(true);
    } else {
      setIsProjectCreator(false);
    }
  }, [fetchProjectSuccess]);

  useDidUpdateEffect(() => {
    const reworks = isProjectCreator ? ownerReworkType : partnerReworkType;
    setReworkList(!!reworks ? reworks : []);
    return () => {
      setReworkList([]);
    };
  }, [isProjectCreator, ownerReworkType, partnerReworkType]);

  useDidUpdateEffect(() => {
    if (!fetchProjectFailure) return;
    history.push(pageUrl.project.list);
  }, [fetchProjectFailure]);

  return (
    <StyledProject data-component-name="Project">
      {isValidProjectInfo ? (
        <>
          <PlainModal
            isOpen={reworkStatusModalOpen}
            onClose={handleCloseReworkStatusModal}
            width={570}
          >
            <AppModal
              title={t('REWORK_PROGRESS')}
              headerCenterText={''}
              headerCenterTextStyle={{ width: 325 }}
              content={<ProjectReworkModal />}
              contentCardStyle={{
                padding: '0',
                borderRadius: '8px',
              }}
              isCloseIcon={true}
              onCancel={handleCloseReworkStatusModal}
              hideButton={true}
            />
          </PlainModal>
          <PlainModal isOpen={isInfoOpen} onClose={handleCloseInfo} width={660}>
            <CreateProjectInfo from="detail" />
          </PlainModal>
          <PlainModal
            customPaperStyle={{
              backgroundColor: 'white',
              padding: 24,
              borderRadius: 10,
              position: 'absolute',
              left: '50%',
              bottom: '50%',
              transform: 'translate(-50%, 50%)',
              width: 1640,
            }}
            isOpen={isIndicationOpen}
            onClose={handleCloseIndication}
            width={1640}
          >
            <CreateProjectContent from="detail" />
          </PlainModal>
          <PlainModal isOpen={isLibraryOpen} onClose={handleCloseLibrary} width={660}>
            <CreateProjectLibrary />
          </PlainModal>
          <PageTitleGoBack
            title={projectName}
            goBack={handleClickGoToBack}
            date={moment
              .unix(enrollDate)
              .locale(language)
              .format(language === 'en' ? 'MMM. DD. YYYY' : 'YYYY. MM. DD')}
            timelineLegends={{
              owner: !!isOwner && !!ownerName ? ownerName : 'Client',
              partner: !isOwner && !!partnerName ? partnerName : 'Partner',
            }}
            useChat={true}
            useGoldState={false}
            isShowChat={!hasSyncAlarm && isShowChat && !!clientGroupCode}
            onClickChat={handleClickChat}
          />
          <ProjectTimeline />
          <ProjectContents />
          <ProjectChatContainer isShowChat={isShowChat} onClickChat={handleClickChat} />
        </>
      ) : (
        <ProjectSkeleton />
      )}
    </StyledProject>
  );
}

const StyledProject = styled.div`
  position: relative;
  .project__info_top_item {
    position: relative;
    margin-bottom: 20px;
    /* height: 96px; */
    /* height: 128px; */
  }
`;

export default ProjectContainer;
